<template>
  <div :class="b()">
    <!-- 头部组件 -->
    <!-- <header-title ref="headerTitle" id="jmsTitle" v-show="printKey && vaildData(tableOption.header,true)"></header-title> -->

    <!-- 顶部操作栏 -->
    <div :class="b('menu')" class="top-menu" id="jmsTopMenu">
      <!-- 顶部操作栏左  -->
      <!-- TODO permission鉴权要不要在组件里 因为这会触发一个bug 同一个路由多个crud实例 会导致权限篡乱 目前没有这样式情况 但是这不合理-->
      <div :class="b('left')">
          <slot name="menuLeftPre"></slot>
          <el-button type="info"
                      @click="importExcel"
                      icon="iconfont icondaoru"
                      :size="isMediumSize"
                      v-if="vaildData(tableOption.importBtn, false)">{{$lang('导入')}}</el-button>
          <el-button @click="rowAdd"
                      :icon="config.addBtnIcon"
                      :size="isMediumSize"
                      :disabled="tableOption.addDisabled"
                      class="btn-query"
                      v-if="vaildData(tableOption.addBtn, false)">{{$lang('新增')}}</el-button>
          <el-button type="info"
                      @click="deleteRows"
                      icon="iconfont iconqingkongshanchu"
                      :size="isMediumSize"
                      :loading="tableOption.deleteLoading"
                      :disabled="vaildData(tableOption.deleteDisabled, !tableSelect.length)"
                      v-if="vaildData(tableOption.deleteBtn, false) && permission['DELETE'+vaildData(tableOption.perSuffix,'')]">{{$lang('删除')}}</el-button>
          <!-- <el-button  @click="searchChange"
                      :icon="config.searchBtnIcon"
                      :size="isMediumSize"
                      class="btn-query"
                      v-if="vaildData(tableOption.search, true)">{{$lang('查询')}}</el-button>
          <el-button
                      class="btn-query"
                      @click="searchReset"
                      :icon="config.emptyBtnIcon"
                      :size="isMediumSize"
                      v-if="vaildData(tableOption.resetBtn,false)">{{$lang('清空')}}</el-button> -->

          <el-button  class="btn-query"
                      @click="exportExcel"
                      icon="iconfont iconicon_anniu_daochu"
                      :size="isMediumSize"
                      :loading="exportLoading"
                      v-if="vaildData(tableOption.exportBtn, false)">{{$lang('导出')}}</el-button>
          <el-button type="info"
                      @click="exportExcelAll"
                      icon="iconfont icondaochu"
                      :size="isMediumSize"
                      :loading="exportLoading"
                      v-if="vaildData(tableOption.exportAllBtn, false)">{{$lang('导出全部')}}</el-button>
          <el-button  type="info"
                      @click="chartModel"
                      :icon="config.chartBtnIcon"
                      :size="isMediumSize"
                      v-if="vaildData(tableOption.chartBtn,false)">{{$lang('图表模式')}}</el-button>
          <slot name="menuLeft"></slot>
      </div>
    </div>

    <!-- 搜索组件 -->
    <header-search v-model="searchForm" id="jmsSearch" ref="headerSearch" v-show="printKey" v-if="vaildData(tableOption.search,true)">
      <template slot-scope="searchForm" slot="headerSearchSlot" v-if="tableOption.headerSearchslot">
        <slot name="headerSearch" :data='searchForm'></slot>
      </template>
      <template slot-scope="{value, column, dic, size, label, disabled}" v-for="item in searchOption" :slot="item.prop + 'Search'">
        <slot :name="item.prop + 'Search'" v-if="item.searchslot" :value="value" :column="column" :dic="dic" :size="size" :label="label"
          :disabled="disabled" :form="searchForm"></slot>
      </template>
      <template slot="search">
        <slot name="search"></slot>
      </template>
      <template slot="searchMenu">
        <slot name="searchMenu"></slot>
      </template>
    </header-search>

    <!-- 表格中间插槽 -->
    <div id="jmsMenu" class="jms-table-menu" v-if="tableOption.tableHeader">
      <slot name="tableHeader"></slot>
    </div>
    <!-- 头部选择项展示 -->
    <div class="avue-crud__tip" id="jmsTip" v-if="tableOption.tip && tableOption.selection">
      <span class="avue-crud__tip-name">
        {{$lang('已选择')}}
        <span class="avue-crud__tip-count">{{selectLen}}</span>
        {{$lang('项')}}
      </span>
      <el-button type="text" size="small" @click="selectClear" v-if="tableOption.selectClearBtn && tableOption.selection">{{$lang('清 空')}}
      </el-button>
      <slot name="tip"></slot>
    </div>
    <div class="avue-crud__searchExtend" id="jmsSearchExtend" v-if="vaildData(tableOption.searchExtend,false)">
      <slot name="searchExtend"></slot>
    </div>

    <!-- 表格主体 -->
    <el-table v-if="doLayout" v-show="!tableOption.tableHide" ref="table" highlight-current-row v-loading="tableLoading" :data="list"
      :row-key="handleGetRowKeys" :size="controlSize" :border="vaildData(tableOption.border, config.border)"
      :expand-row-keys="tableOption.expandRowKeys" :default-expand-all="tableOption.defaultExpandAll"
      :show-summary="tableOption.showSummary" :summary-method="tableSummaryMethod" :span-method="tableSpanMethod"
      :stripe="tableOption.stripe" :selectable="tableOption.selectable" :show-header="tableOption.showHeader"
      :default-sort="tableOption.defaultSort" :row-class-name="rowClassName || rowDefaultClassName" :cell-class-name="cellClassName"
      :header-cell-class-name="headerCellClassName" :max-height="tableOption.maxHeight"
      :height="tableOption.tableHeight || tableHeight - (tableOption.fixHeight || 0)" :width="setPx(tableOption.width,config.width)"
      @current-change="currentRowChange" @expand-change="expandChange" @row-click="rowClick" @row-dblclick="rowDblclick"
      @cell-mouse-enter="cellMouseEnter" @cell-mouse-leave="cellMouseLeave" @cell-click="cellClick" @cell-dblclick="cellDblclick"
      @selection-change="selectionChange" @select="select" @select-all="selectAll" @sort-change="sortChange">
      <!-- 暂无数据提醒 -->
      <template slot="empty">
        <div :class="b('empty')">
          <!-- 判断是否存在name=empty的插槽 -->
          <slot name="empty" v-if="$slots.empty"></slot>
          <!-- 不存在name=empty插槽 -->
          <template v-else>
            <!-- 区分loading状态以及异常状态 loading -->
            <avue-empty :loadingState="2" size="240"
              image="data:image/png;base64,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"
              :desc="tableOption.emptyText || $lang('暂无数据')"></avue-empty>
          </template>
        </div>
      </template>

      <!-- 表格展开列  -->
      <el-table-column type="expand" width="60" align="center" fixed="left" v-if="tableOption.expand">
        <template slot-scope="props">
          <slot :row="props.row" name="expand"></slot>
        </template>
      </el-table-column>

      <!-- 选择框 -->
      <el-table-column v-if="tableOption.selection" type="selection" width="50" fixed="left" align="center"
        :selectable="tableOption.selectable" :reserve-selection="vaildData(tableOption.reserveSelection,false)">
      </el-table-column>

      <!-- 序号 -->
      <el-table-column v-if="this.vaildData(tableOption.index,true)" type="index" width="60" fixed="left" align="center"
        :label="$lang(tableOption.indexLabel || config.indexLabel)" :index="indexMethod"></el-table-column>

      <!-- 占位符号解决ele问题 -->
      <!-- <el-table-column width="0px" v-show="false"></el-table-column> -->

      <!-- 表格所有列 -->
      <column :columnOption="tableColumn">
        <!-- 每列的自定义slot -->
        <template v-for="item in propOption" slot-scope="scope" :slot="item.prop">
          <slot :row="scope.row" :dic="scope.dic" :size="scope.size" :label="scope.label" :name="item.prop"></slot>
        </template>
      </column>

      <!-- 操作列 -->
      <el-table-column fixed="right" :label="$lang(tableOption.rightTitle || '操作')" v-if="vaildData(tableOption.menu,config.menu)"
        :header-align="tableOption.menuheaderAlign || config.menuheaderAlign"
        :width="isMobile ? (tableOption.menuXsWidth || config.menuXsWidth) : ( tableOption.menuWidth || config.menuWidth)">
        <template slot="header" v-if="vaildData(tableOption.menu,config.menu) && tableOption.dynamicOptions">
          <div class="operate-column"><span>{{$lang('操作')}}</span>
            <el-button icon="iconfont iconshaixuan filter" type="text" @click="openDynamicDialog"></el-button>
          </div>
        </template>
        <template slot-scope="{ row, $index, dic, label }">
          <template v-if="['button','text','icon'].includes(menuType)">
            <!-- 行内编辑保存按钮 -->
            <el-button type="text" :icon="row.$cellEdit ? config.saveBtnIcon : config.editBtnIcon" :size="isMediumSize"
              :disabled="btnDisabled" @click.stop="rowCell(row, $index)" :title="$lang('保存')"
              v-if="tableOption.cellBtn && permission['EDIT'+vaildData(tableOption.perSuffix,'')]">{{row.$cellEdit ? 'save' : 'edit'}}
            </el-button>
            <!-- 行内编辑取消按钮 -->
            <el-button type="text" :icon="config.cancelBtnIcon" :size="isMediumSize" :disabled="btnDisabled"
              @click.stop="rowCanel(row, $index)" :title="$lang('取消')" v-if="row.$cellEdit && tableOption.cancelBtn"></el-button>

            <!-- 查看按钮 -->
            <el-button type="text" :size="isMediumSize" :disabled="tableOption.viewDisabled"
              :class="{ 'icon-btn-disabled':tableOption.viewDisabled }" @click.stop="view(row, $index)" :title="$lang('详情')" :style="tableOption.viewColor"
              v-if="tableOption.viewBtn" >{{$lang('详情')}}
            </el-button>

            <!-- 查看按钮-图标 -->
            <el-button type="icon" :size="isMediumSize" :disabled="tableOption.viewIconDisabled" class="btn-icon icon-iconfont iconfont icon-xiangqing"
              :class="{ 'icon-btn-disabled':tableOption.viewIconDisabled }" @click.stop="view(row, $index)" :title="$lang('详情')"
              v-if="tableOption.viewIconBtn" >
            </el-button>

            <!-- 编辑按钮 -->
            <el-button type="text" :size="isMediumSize" :disabled="tableOption.editDisabled"
              :class="{ 'icon-btn-disabled':tableOption.editDisabled }" @click.stop="rowEdit(row, $index)" :title="$lang('编辑')"
              v-if="tableOption.editBtn" >{{$lang('编辑')}}
              </el-button>

             <!-- 编辑按钮-图标 -->
            <el-button type="icon" :size="isMediumSize" :disabled="tableOption.editIconDisabled" class="btn-icon icon-iconfont iconfont icon-bianji"
              :class="{ 'icon-btn-disabled':tableOption.editIconDisabled }" @click.stop="rowEdit(row, $index)" :title="$lang('编辑')"
              v-if="tableOption.editIconBtn" >
              </el-button>

            <!-- 删除按钮 -->
            <el-button type="text" :icon="config.delBtnIcon" :size="isMediumSize" :disabled="tableOption.delDisabled"
              :class="{ 'icon-btn-disabled':tableOption.delDisabled }" @click.stop="rowDel(row, $index)" :title="$lang('删除')"
             v-if="tableOption.delBtn !== false && permission['DELETE'+vaildData(tableOption.perSuffix,'')] && row.$delete !== false"></el-button>
          </template>

          <el-dropdown v-else-if="menuType === 'menu'" style="margin-right:9px;">
            <el-button type="primary" :size="isMediumSize">
              {{$lang('更 多')}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-if="tableOption.viewBtn !== false && permission['DETAIL'+vaildData(tableOption.perSuffix,'')] && row.$view !== false"
                @click.native="rowView(row, $index)">{{$lang('查 看')}}</el-dropdown-item>
              <el-dropdown-item divided
                v-if="tableOption.editBtn !== false && permission['EDIT'+vaildData(tableOption.perSuffix,'')] && row.$edit !== false"
                @click.native="rowEdit(row, $index)"> {{$lang('编 辑')}}</el-dropdown-item>
              <el-dropdown-item divided
                v-if="tableOption.delBtn !== false && permission['DELETE'+vaildData(tableOption.perSuffix,'')] && row.$delete !== false"
                @click.native="rowDel(row, $index)">{{$lang('删 除')}}</el-dropdown-item>
              <slot name="menuBtn" :row="row" :dic="dic" :label="label" :index="$index"></slot>
            </el-dropdown-menu>
          </el-dropdown>
          <slot name="menu" :row="row" :disabled="btnDisabled" :size="isMediumSize" :index="$index"></slot>
        </template>
      </el-table-column>
      <el-table-column v-if="tableOption.dynamicOptions && !vaildData(tableOption.menu,config.menu)" align="center" width="30"
        fixed="right">
        <template slot="header">
          <el-button style="margin-left: -5px;" icon="iconfont iconshaixuan filter" type="text" @click="openDynamicDialog"></el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <table-page ref="tablePage" id="jmsPagination" v-show="printKey&& tableOption.pagination!==false"></table-page>

    <!-- 表单 -->
    <dialog-form ref="dialogForm" :class="dialogClass" :columnFormOption="columnFormOption" v-model="tableForm"
      v-if="(tableOption.customAdd || tableOption.customEdit) !== true">
      <template slot-scope="{value, column, dic, size, label, disabled}" v-for="item in columnFormOption" :slot="item.prop">
        <slot :value="value" :column="column" :dic="dic" :size="size" :label="label" :disabled="disabled" :row="tableForm"
          :index="tableIndex" :name="item.prop+'Form'" v-if="item.formslot"></slot>
      </template>
      <template slot-scope="{tableForm,boxType,size}" slot="menuForm">
        <slot name="menuForm" :size="size" :type="boxType"></slot>
      </template>
    </dialog-form>

    <!-- 查看弹窗 -->
    <el-drawer ref="dialogView" size="35%" :open="viewOpen" lock-scroll v-if="(tableOption.customView) !== true"
      :custom-class="vaildData(tableOption.customClass,config.customClass)" :fullscreen="tableOption.dialogFullscreen"
      :modal-append-to-body="false" :append-to-body="true" :close-on-press-escape="tableOption.dialogEscape" :close-on-click-modal="false"
      :title="tableOption.viewTitle ||functionName + ' ' + $lang('详情')" :modal="tableOption.dialogModal" :show-close="tableOption.dialogCloseBtn"
      :visible.sync="viewVisible" :width="tableOption.dialogWidth || '824px'" @close="closeViewDialog">
      <div :style="{ overflow:'unset' }" ref="content" v-loading="dialogLoading">
        <el-scrollbar style="height:100%">
          <div :class="b('dialog', ['overflow'])">
            <avue-detail v-model="viewData" :option="this.tableOption" v-if="viewVisible" :styleType="'noBorder'">
              <!-- 渲染查看插槽 viewslot  -->
              <template v-for="item in columnOption">
                <template :slot="item.prop + 'View'" v-if="item.viewslot">
                  <slot :data="viewData[item.prop]" :row="viewData" :name="item.prop + 'View'"></slot>
                </template>
              </template>
            </avue-detail>
          </div>
        </el-scrollbar>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button :size="controlSize" @click="closeViewDialog">{{$lang('关 闭')}}</el-button>
      </span> -->
    </el-drawer>

    <!-- <dialog-column ref="dialogColumn" :dynamicColumns="dynamicColumns"></dialog-column> -->
    <!-- tableOption.dynamicOptions.getUrl -->
    <!-- 动态列 -->
    <!-- <drag-column v-if="dynamicColumns.length"
                  ref="dragColumn"
                  :dynamicColumns="dynamicColumns"
                  :defaultUrl="tableOption.dynamicOptions.defaultUrl"></drag-column> -->
  </div>
</template>
<script>
import create from '../../core/create'
import init from '../../core/crud/init.js'
import tablePage from './table-page'
import headerSearch from './header-search'
import column from './column'

// import dragColumn from '@/components/jms-widget/jms-table/drag-column';
import dialogForm from './dialog-form';
import config from './config.js';
import treeToArray, { addAttrs } from '../../core/crud/eval';
import { calcCascader } from '../../core/common/dataformat';
// 导入
import find from 'lodash/find'
import server from '../../core/crud/pool.js'
import { RESPONSE_CODE } from '@public/http/config'
import fetch from '@public/http/request'
import {post} from '@public/http/request'
import {siteApi} from '@public/api/index'

import remove from 'lodash/remove'
import forEach from 'lodash/forEach'
import qs from 'qs'
import Sortable from 'sortablejs'
import { mapGetters } from 'vuex';
import { transferText } from "@public/utils/common";
export default create({
  name: 'crud',
  mixins: [init('crud')],
  provide() {
    return {
      crud: this
    }
  },
  components: {
    column,
    tablePage, // 分页
    headerSearch, // 搜索
    // dragColumn,
    dialogForm // 分页,
  },
  data() {
    return {
      config,
      functionName: '', // 当前模块的名字
      treeProp: '', // tree的字段
      boxType: 'add', // 弹窗类型
      tableIndex: -1, // 当前处理行的索引
      doLayout: false, // 是否显示表格
      keyBtn: false, // 是否显示表格
      isChild: false, // 是否包含子集
      viewVisible: false, // 查看可见
      columnConfVisible: false, // 查看可见
      printKey: true,
      dialogLoading: false, // 弹窗loading
      list: [], // 表格展示的数据
      expandList: [], // 展开的列
      formIndexList: [],
      tableSelect: [], // 已选中的数据
      sumsList: [], // 求和项
      dynamicColumns: [], // 动态列配置项
      searchOption: [], // 搜索的配置
      tableColumn: [], // 表格列配置
      tableForm: {}, // 弹窗表单
      searchForm: {}, // 搜索表单
      formRules: {}, // 表单校验
      formCellRules: {}, // 行编辑校验规则
      permission: {}, // 当前模块权限信息
      cascaderDicList: {}, // 级联字典
      formCascaderList: {}, // 表单级联
      viewData: {}, // 查看数据
      oldFormData: {}, // 上一次的数据
      tempActionCol: ['DELETE', 'EDIT', 'DETAIL'], // 初始按钮
      actionCompare: 11,
      sortableInstance: null,
      hasAdvanced: false,
      isMenuShow: false // 只有查询权限
    }
  },
  created() {
    // 初始化权限信息
    this.permissionInit()
    // 初始化数据 包括初始化操作按钮的显示影藏
    this.dataInit()
    // TODO 应该只初始化搜索栏的字典
    this.handleLoadDic()
    // 初始标题信息 TODO 要在弹窗初始化时执行
    this.titleInit()
    // 动态列初始化
    this.initSearchOption()
    // 初始化列
    this.initTableColumn()
    // 初始操作列
    this.initActionColWidth()
  },
  mounted() {
    this.doLayout = false
    this.$nextTick(() => {
      if (this.tableOption.dynamicOptions) {
        // 动态列初始化
        this.initDynamicColumn()
      } else {
        this.doLayout = true
      }
      // 如果有搜索激活搜索
      // if (this.$refs.headerSearch) this.$refs.headerSearch.init();
      this.$nextTick(() => {
        // 是否开启表格拖拽排序
        if (this.tableOption.sortable) {
          setTimeout(this.setSort(), 0)
        }
      })
    })
    // 延迟1s执行拖拽初始化，避免出现节点未初始化完成的异常
    // setTimeout(this.columnDrop, 1000)
    // 是否需要高级搜索按钮
    if (!this.$refs.headerSearch) {
      this.hasAdvanced = false
    } else {
      const height = this.$refs.headerSearch.$el.offsetHeight
      if (height > 75) {
        this.hasAdvanced = true
      } else {
        this.hasAdvanced = false
      }
    }
  },
  computed: {
    // ...mapGetters(['btnList']),
    // 弹窗高度
    dialogHeight() {
      return this.setPx(
        this.vaildData(this.tableOption.dialogHeight, config.dialogHeight)
      )
    },
    // 全部配置项
    options() {
      return this.tableOption || {}
    },
    // 列的配置集合
    columnOption() {
      return this.tableOption.column || []
    },
    // 返回所有的配置项  包括children里面的配置
    propOption() {
      let result = []
      const ctx = this
      // 递归查找所有的属性配置
      function findProp(list) {
        list.forEach((ele) => {
          if (ele.prop) {
            result.push(ele)
          }
          if (ele.children) {
            ctx.isChild = true
            findProp(ele.children)
          }
        })
      }
      findProp(this.columnOption)
      // 处理联动字段
      if (this.isChild) {
        result = calcCascader(result)
      } else {
        result = calcCascader(this.columnOption)
      }

      if (this.isTree) this.treeProp = result[0].prop
      return result
    },
    // 表单的配置 TODO <动态列变化会影响到表单查看,要独立开来>
    columnFormOption() {
      if (this.isGroup) {
        const list = []
        this.options.group.forEach((ele) => {
          if (!ele.column) return
          ele.column.forEach((column) => {
            list.push(column)
          })
        })
        return list
      } else {
        return this.propOption
      }
    },
    // // 搜索栏的配置
    // columnSearchOption () {
    //   const option = this.deepClone(this.columnOption || []).filter((item) => item.search === true)
    //   return option;
    // },
    // 是否包含组
    isGroup() {
      return !this.validatenull(this.tableOption.group)
    },
    // 展开的级别
    expandLevel() {
      return this.options.expandLevel || 0
    },
    // 是否展开全部
    expandAll() {
      return this.options.expandAll || false
    },
    // 是否是树形表格
    isTree() {
      return this.vaildData(this.options.tree, false)
    },
    // 数据"id"的"key"
    idKey() {
      return this.tableOption.idKey || 'id'
    },
    idKeys() {
      return this.tableOption.idKeysParams;
    },
    // 操作按钮不可用
    btnDisabled() {
      // return this.$refs.dialogForm.keyBtn && this.tableOption.cellBtn;
    },
    // 合计的配置集合
    sumColumnList() {
      return this.tableOption.sumColumnList || []
    },
    // 已选中的长度
    selectLen() {
      return this.tableSelect ? this.tableSelect.length : 0
    }
  },
  watch: {
    // 解决登录直接进入页面permissionInit读取不到的情况
    // btnList: {
    //   handler(val) {
    //     this.permissionInit()
    //   },
    //   deep: true
    // },
    // 双向绑定弹窗表单的值
    tableForm: {
      handler() {
        this.$emit('input', this.tableForm)
      },
      deep: true
    },
    // 传入弹窗表单表的值 @Object
    value: {
      handler() {
        this.formVal()
      },
      deep: true
    },
    // 分页参数配置项
    page: {
      handler() {
        this.$refs.tablePage.pageInit()
      },
      deep: true
    },
    // 监听组件配置是否变化，变化则刷新
    propOption() {
      this.refreshOptions()
    },
    // TODO 配置变化更新显示列
    // propOption () {
    //   // this.$refs.dialogColumn.columnInit();
    // },
    // 表格展示的数据
    data() {
      this.dataInit()
      // 初始化级联字典  TODO表格不需要初始化字典
      // this.handleLoadCascaderDic();
      this.$nextTick(() => {
        this.$refs.table && this.$refs.table.doLayout()
      })
    },
    // 路由切换重新计算布局
    $route(to, form) {
      this.$refs.table.doLayout()
    }
  },
  props: {
    dialogClass: {
      type: String
    },
    // 弹窗表单传入的值
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    spanMethod: Function, // 合并单元格的方法
    summaryMethod: Function, // 合计的方法
    beforeClose: Function, // 弹窗关闭之前
    beforeOpen: Function, // 弹窗开启之前
    rowClassName: Function, // 行类名
    cellClassName: Function, // 单元格类名
    headerCellClassName: Function, // 行类名
    uploadBefore: Function, // 开始上传之前
    uploadAfter: Function, // 上传后
    page: {
      type: Object,
      default() {
        return {}
      }
    },
    tableLoading: {
      type: Boolean,
      default: false
    },
    exportLoading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      required: true,
      default: () => {
        return []
      }
    }
  },
  methods: {
    refreshOptions() {
      // 初始化权限信息
      this.permissionInit()
      // 初始化数据 包括初始化操作按钮的显示影藏
      this.dataInit()
      // TODO 应该只初始化搜索栏的字典
      this.handleLoadDic()
      // 初始标题信息 TODO 要在弹窗初始化时执行
      // this.titleInit()
      // 动态列初始化
      this.initSearchOption()
      // 初始化列
      this.initTableColumn()
      // 如果配置了动态列，需刷新动态列
      if (this.tableOption.dynamicOptions) {
        this.refreshDynamicColumn()
      }
    },
    chartModel() {
      this.$emit('custom-chart', {})
    },
    /** ********新增的方法start****************************************** */
    columnDrop() {
      // 获取表格配置中的复选框配置|索引列配置|展开列配置
      const { selection, index, expand, useDrag = true } = this.tableOption
      // 是否使用拖拽
      if (!useDrag) return
      // 获取当前实例对应的节点
      const pNode = this.$refs.table.$el
      // 获取表格头部的节点
      const tr = pNode.querySelector('.has-gutter tr')
      // 挂载节点到拖拽初始化
      this.sortableInstance = Sortable.create(tr, {
        // 动画时间
        animation: 180,
        // 延迟时间
        delay: 0,
        // 拖拽结束的回调
        onEnd: (e) => {
          // 拖拽变动的列索引
          const { newIndex, oldIndex } = e
          let prevLen = 0
          // 存在复选框
          if (selection) prevLen++
          // 存在索引列
          if (this.vaildData(index, true)) prevLen++
          // 存在展开列
          if (expand) prevLen++
          // 获取表头主体dom节点
          const header = pNode.querySelector('.el-table__header-wrapper')
          // 获取表头主体下的表头行
          const headerTr = [...header.querySelectorAll('tr')][0]
          // 拷贝表头主体下的表头行（用于后续表格列配置渲染后，处理表头恢复）
          const cloneThList = headerTr.cloneNode(true)
          // 回去拖拽的列
          const oldObj = this.tableColumn[oldIndex - prevLen]
          // 删除配置里面的拖拽列
          this.tableColumn.splice(oldIndex - prevLen, 1)
          // 把拖拽的列添加到目标位置
          this.tableColumn.splice(newIndex - prevLen, 0, oldObj)
          // 配置渲染完成后
          this.$nextTick(() => {
            // 获取表头主体下的表头单元格列表
            const tdList = [...headerTr.querySelectorAll('th')]
            // 获取上面备份的表头主体下的表头单元格列表
            const tdListOld = [...cloneThList.querySelectorAll('th')]
            // 遍历单元格列表
            tdList.forEach((item, index) => {
              const curNodeChild = item.children[0]
              const oldNodeChild = tdListOld[index].children[0]
              if (
                oldIndex > newIndex &&
                index >= newIndex &&
                index <= oldIndex
              ) {
                // 从右往左拖拽
                // 替换新的节点为上一次拖拽后的节点
                // headerTr.replaceChild(tdListOld[index], item)
                if (curNodeChild) {
                  item.children[0].replaceChild(
                    oldNodeChild.childNodes[0],
                    curNodeChild.childNodes[0]
                  )
                }
              } else if (
                oldIndex < newIndex &&
                index <= newIndex &&
                index >= oldIndex
              ) {
                // 从左往右拖拽
                // 替换新的节点为上一次拖拽后的节点
                // headerTr.replaceChild(tdListOld[index], item)
                if (curNodeChild) {
                  item.children[0].replaceChild(
                    oldNodeChild.childNodes[0],
                    curNodeChild.childNodes[0]
                  )
                }
              }
            })
          })
        }
      })
    },
    // 斑马纹
    rowDefaultClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return ''
      } else {
        return 'row2n-class'
      }
    },
    // 初始化权限信息
    permissionInit() {
      // const data = this.$store.state.base.btnList[this.$route.name]
      // this.permission = data || {}
      // this.isMenu()
    },
    // 根据返回按钮是否显示操作栏
    isMenu() {
      // const menuList = Object.keys(this.permission)
      // const btnList = ['EDIT', 'DETAIL', 'DELETE', 'STARTUSE', 'STOPUSE', 'CHECK', 'AUTH']
      // btnList.forEach(item => {
      //   if (menuList.includes(item)) {
      //     this.isMenuShow = true
      //   }
      // })
    },
    initActionColWidth() {
      if (this.validatenull(this.permission)) {
        this.actionCompare = 0
        return
      }
      let actionCompare = this.actionCompare
      if (this.tableOption.dynamicOptions) {
        // 动态列初始化
        actionCompare += 20
      }
      // 设置操作列宽度
      this.tempActionCol.forEach((item) => {
        // viewBtn editBtn delBtn
        // const
        let optionBtnstr = ''
        if (item === 'DELETE') {
          optionBtnstr = 'delBtn'
        } else if (item === 'DETAIL') {
          optionBtnstr = 'viewBtn'
        } else if (item === 'EDIT') {
          optionBtnstr = 'editBtn'
        }
        const optionBtn = this.tableOption[optionBtnstr]
        if (this.permission[item] && optionBtn !== false) {
          actionCompare += 33
        }
      })
      this.actionCompare = actionCompare === 11 ? 0 : actionCompare
    },
    // 初始化标题
    titleInit(title = '') {
      this.functionName = this.$lang(title || this.$route.meta.title)
    },
    // 获取查看数据
    async getViewData(row) {
      this.viewOpen(this.viewData)
      if (this.tableOption.useRowView) {
        this.viewData = row
        return
      }
      if (this.tableOption.viewData) {
        this.viewData = this.tableOption.viewData
      } else {
        this.dialogLoading = true
        let reqUrl
        if (!this.tableOption.formatViewReq) {
         if (this.tableOption.isIdKeyObject) {
           if (this.idKeys.id) {
            reqUrl = `${this.tableOption.viewUrl}?${this.idKeys.id}=${
              row[this.idKeys.id]
            }`;
           } else {
             reqUrl = `${this.tableOption.viewUrl}?${this.idKeys.orderNo}=${
              row[this.idKeys.orderNo]
            }`;
           }
            
          } else {
            reqUrl = `${this.tableOption.viewUrl}?${this.idKey}=${
              row[this.idKey]
            }`;
          }
        } else {
          reqUrl = `${this.tableOption.viewUrl}${this.tableOption.formatViewReq(
            row
          )}`
        }
        const resData = await fetch.get(reqUrl)
        // chore: 新增字符串反转实体字符
        resData.data && Object.keys(resData.data).forEach(item => {
          if (Object.prototype.toString.call(resData.data[item]) == "[object String]") {
            resData.data[item] = transferText(resData.data[item])
          }
        })
        this.dialogLoading = false
        if (!resData || (!resData.code && resData.code !== 0)) {
          this.$message.error(resData.msg || this.$lang("请求异常，请联系客服"))
        } else {
          this.viewData = this.tableOption.formateViewData
            ? this.tableOption.formateViewData(resData.data)
            : resData.data
        }
      }
      this.viewOpen(this.viewData)
      this.$emit('after-row-view', this.viewData)
    },
    // 删除表格中的某一项
    deleteItem(row) {
      this.$confirm(this.$lang('确认删除该条信息？'), this.$lang('温馨提示'), {
        confirmButtonText: this.$lang('确定'),
        cancelButtonText: this.$lang('取消'),
        iconClass: 'el-icon-warning-outline',
        type: 'warning',
        confirmButtonClass: 'comfirm-btn',
        closeOnClickModal: false
      }).then(() => {
        this.deleteReq(row)
      })
    },
    // 删除请求
    async deleteReq(row) {
      let data
      if (!this.tableOption.formatDeleteReq) {
        data = { id: row[this.idKey] }
      } else {
        data = this.tableOption.formatDeleteReq(row)
      }
      const res = await server.reqDel(this.tableOption.deleteUrl, data)
      if (res.code === RESPONSE_CODE.SUCCESS) {
        this.$message.success('操作成功')
        this.$emit('delete-success')
      }
    },
    // 关闭查看弹窗
    closeViewDialog() {
      this.tableIndex = -1
      this.tableForm = {}
      this.viewVisible = false
      this.keyBtn = false
      this.hide()
    },
    // 关闭查看回调
    hide() {
      const callack = () => {
        this.viewData = {}
      }
      if (typeof this.$parent.beforeClose === 'function') {
        this.$parent.beforeClose(callack, this.boxType, this.viewData)
      } else {
        callack()
      }
    },
    // 获取编辑数据
    fetchFormData(row) {
      return new Promise((resolve, reject) => {
        let reqUrl
        if (!this.tableOption.viewUrl) {
          resolve(row)
          return
        }
        this.dialogLoading = true
        if (!this.tableOption.formatViewReq) {
          reqUrl = `${this.tableOption.viewUrl}?${this.idKey}=${
            row[this.idKey]
          }`
        } else {
          reqUrl = `${this.tableOption.viewUrl}${this.tableOption.formatViewReq(
            row
          )}`
        }
        fetch.get(reqUrl).then((res) => {
          if (res.code === RESPONSE_CODE.SUCCESS) {
            // 判断配置是否有fetchDataCb参数且为函数，符合则执行
            typeof this.tableOption.fetchDataCb === 'function' &&
              this.tableOption.fetchDataCb(res.data)
            resolve(res.data)
          } else {
            reject(res)
            this.$message({ type: 'error', message: res.msg })
          }
          this.dialogLoading = false
        })
      })
    },
    // 更新权限信息
    refreshPower(data) {
      this.permission = data
    },
    // 打开动态列弹窗
    openDynamicDialog() {
    //   this.$refs.dragColumn.openDialog();
    },
    // 远程配置和本地配置合并
    initDynamicColumn() {
      this.doLayout = false
      const columnProps = {}
      const columns = []
      this.columnOption.forEach((item, idx) => {
        columnProps[item.prop] = item
      })
      this.fetchColumnData(this.tableOption)
        .then((customColumnDefs) => {
          this.dynamicColumns = customColumnDefs
          const columnsShow = JSON.parse(
            JSON.stringify(
              this.dynamicColumns.filter((item) => item.show === true)
            )
          )
          columnsShow.forEach((item) => {
            const col = columnProps[item.name]
            if (col) {
              if (col.hide !== undefined) {
                col.hide = false
              }
              columns.push(Object.assign(item, col))
            } else {
              columns.push({
                label: item.column,
                prop: item.name,
                show: item.show
              })
            }
          })
          this.tableColumn = columns
          this.doLayout = true
          setTimeout(() => {
            this.$refs.table && this.$refs.table.doLayout()
          }, 0)
        })
        .catch((res) => {
          this.doLayout = true
        })
    },
    refreshDynamicColumn() {
      this.doLayout = false
      const columnProps = {}
      const columns = []
      this.columnOption.forEach((item, idx) => {
        columnProps[item.prop] = item
      })
      const columnsShow = JSON.parse(
        JSON.stringify(this.dynamicColumns.filter((item) => item.show === true))
      )
      columnsShow.forEach((item) => {
        const col = columnProps[item.name]
        if (col) {
          if (col.hide !== undefined) {
            col.hide = false
          }
          columns.push(Object.assign(item, col))
        } else {
          columns.push({
            label: item.column,
            prop: item.name,
            show: item.show
          })
        }
      })
      this.tableColumn = columns
      this.doLayout = true
      setTimeout(() => {
        this.$refs.table && this.$refs.table.doLayout()
      }, 0)
    },
    // 获取动态列数据
    fetchColumnData(tableOption) {
      return new Promise((resolve, reject) => {
        const reqUrl = tableOption.dynamicOptions.getUrl
        fetch
          .get(`${reqUrl}?` + qs.stringify(tableOption.dynamicOptions.params))
          .then((res) => {
            if (res.code === RESPONSE_CODE.SUCCESS) {
              resolve(res.data || [])
            } else {
              reject(res)
              this.$message({ type: 'error', message: res.msg })
            }
          })
          .catch((res) => {
            // this.tableColumn = tableOption.column
            this.doLayout = true
            setTimeout(() => {
              this.$refs.table && this.$refs.table.doLayout()
            }, 0)
          })
      })
    },
    // 设置动态列数据
    setCustomColumn(params) {
      return new Promise((resolve, reject) => {
        const reqUrl = this.tableOption.dynamicOptions.saveUrl
        const baseobj = Object.assign(
          {},
          this.tableOption.dynamicOptions.params,
          params
        )
        fetch.post(`${reqUrl}`, baseobj).then((res) => {
          if (res.code === RESPONSE_CODE.SUCCESS) {
            this.$message.success('操作成功')
            this.initDynamicColumn()
            resolve(res)
          } else {
            this.$message({ type: 'error', message: res.msg })
            resolve(res)
          }
        })
      })
    },
    // 初始化搜索配置
    initSearchOption() {
      const option = this.deepClone(this.propOption || []).filter(
        (item) => item.search === true
      )
      const sortItems = remove(option, function (item) {
        return typeof item.sort === 'number'
      })
      // forEach(sortItems, (item) => {
      //   option.splice(item.sort, 0, item)
      // })

      this.searchOption = sortItems.sort((a, b) => { return a.sort - b.sort })

      // this.searchOption = option
    },
    // 初始化列配置
    initTableColumn() {
      this.tableColumn = this.option.column.filter((o) => o.hide !== true)
    },
    /** ********新增的方法end****************************************** */
    // 开启排序
    setSort() {
      if (!window.Sortable) {
        console.error('please npm install Sortable -S')
        return
      }
      const el = this.$refs.table.$el.querySelectorAll(
        '.el-table__body-wrapper > table > tbody'
      )[0]
      this.sortable = window.Sortable.create(el, {
        ghostClass: 'avue-crud__sortable',
        onEnd: (evt) => {
          const oldindex = evt.oldIndex
          const newindex = evt.newIndex
          const targetRow = this.list.splice(oldindex, 1)[0]
          this.list.splice(newindex, 0, targetRow)
          this.$emit(
            'sortable-change',
            oldindex,
            newindex,
            targetRow,
            this.list
          )
        }
      })
    },
    // 更新弹窗表单或者搜索栏的字典,用 refname 调用 dialogForm 或 headerSearch 实例的方法
    updateDic(prop, list, refname = 'dialogForm', params) {
      this.$refs[refname] && this.$refs[refname].updateDic(prop, list, params)
    },
    showRow(row) {
      // const index = row.rowIndex;
      const show = row.row._parent
        ? row.row._parent._expand && row.row._parent._show
        : true
      row.row._show = show
      return show
        ? 'animation:treeTableShow 1s;-webkit-animation:treeTableShow 1s;'
        : 'display:none;'
    },
    // 对部分表单字段进行校验的方法
    validateField(val) {
      return this.$refs.dialogForm.$refs.tableForm.validateField(val)
    },
    handleGetRowKeys(row) {
      const rowKey = row[this.idKey]
      return rowKey
    },
    // 初始化弹窗表单规则
    rulesInit() {
      this.formRules = {}
      this.propOption.forEach((ele) => {
        if (ele.rules) this.formRules[ele.prop] = ele.rules
        if (ele.rules && ele.cell) this.formCellRules[ele.prop] = ele.rules
      })
    },
    // 取消表格选择
    selectClear() {
      this.$refs.table.clearSelection()
    },
    // 选中/取消选中
    toggleRowSelection(row, selected) {
      this.$refs.table.toggleRowSelection(row, selected)
    },
    // 展开/取消展开
    toggleRowExpansion(row, expanded) {
      this.$refs.table.toggleRowExpansion(row, expanded)
    },
    // 高亮某一行
    setCurrentRow(row) {
      this.$refs.table.setCurrentRow(row)
    },
    // 返回序号
    indexMethod(index) {
      return (
        index +
        1 +
        ((this.$refs.tablePage.defaultPage.currentPage || 1) - 1) *
          (this.$refs.tablePage.defaultPage.pageSize || 10)
      )
    },
    // 弹窗表单赋值
    formVal() {
      Object.keys(this.value).forEach((ele) => {
        this.$set(this.tableForm, ele, this.value[ele])
      })
    },
    // 初始化数据
    dataInit() {
      if (this.isTree) {
        const data = this.data
        if (data.length === 0) {
          this.list = []
          return
        }
        addAttrs(this, data, {
          expand: this.expandAll,
          expandLevel: this.expandLevel
        })
        this.list = treeToArray(this, data)
      } else {
        this.list = this.data
      }
      /*
       *存在操作按钮根据业务状态显示隐藏操作按钮 初始化显隐参数 避免在template中使用函数处理 以提高组件性能
       *@Description: tableOption.btnsVisible()
       *@param {ele} type Object
       *@return [type] Object 例如 { view: false, edit:false }
       *@Date: 2019-08-01 10:59:27
       */
      if (typeof this.tableOption.btnsVisible === 'function') {
        this.list.forEach((ele, index) => {
          const btnVisible = this.tableOption.btnsVisible(ele) || {}
          ele.$view = btnVisible.view
          ele.$edit = btnVisible.edit
          ele.$delete = btnVisible.delete
        })
      }
      // 格式化每列数据
      this.tableColumn.forEach((item) => {
        if (item.formatData && typeof item.formatData === 'function') {
          this.list.forEach((itm) => {
            // 拷贝一份原始prop
            if (!itm[item.prop + 'Origin']) {
              itm[item.prop + 'Origin'] = itm[item.prop]
            }
            itm[item.prop] = item.formatData(itm[item.prop])
          })
        }
      })
    },
    // 展开或则关闭
    expandChange(row, expand) {
      this.expandList = [...expand]
      this.$emit('expand-change', row, expand)
    },
    // 设置单选
    currentRowChange(val) {
      this.$emit('current-row-change', val)
    },
    // 刷新事件
    refreshChange() {
      this.$emit('refresh-change', {
        page: this.defaultPage,
        searchForm: this.searchForm
      })
    },
    // 选中行数据
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.table.toggleRowSelection(row)
        })
      } else {
        this.$refs.table.clearSelection()
      }
    },
    // 选择回调
    selectionChange(val) {
      this.tableSelect = val
      this.$emit('selection-change', this.tableSelect)
      // console.log(this.tableSelect, '---------==' )
    },
    // 单个选择回调
    select(selection, row) {
      this.$emit('select', selection, row)
    },
    // 点击勾选全选 Checkbox
    selectAll(selection) {
      this.$emit('select-all', selection)
    },
    // 排序回调
    sortChange(val) {
      this.$emit('sort-change', val)
    },
    // 行双击
    rowDblclick(row, event) {
      this.$emit('row-dblclick', row, event)
    },
    // 行单机
    rowClick(row, event, column) {
      this.$emit('row-click', row, event, column)
    },
    // 当单元格 hover 进入时会触发该事件
    cellMouseEnter(row, column, cell, event) {
      this.$emit('cell-mouse-enter', row, column, cell, event)
    },
    // 当单元格 hover 退出时会触发该事件
    cellMouseLeave(row, column, cell, event) {
      this.$emit('cell-mouse-leave', row, column, cell, event)
    },
    // 当某个单元格被点击时会触发该事件
    cellClick(row, column, cell, event) {
      this.$emit('cell-click', row, column, cell, event)
    },
    // 当某个单元格被双击击时会触发该事件
    cellDblclick(row, column, cell, event) {
      this.$emit('cell-dblclick', row, column, cell, event)
    },
    // 行编辑点击
    rowCell(row, index) {
      if (row.$cellEdit) {
        this.rowCellUpdate(row, index)
      } else {
        this.rowCellEdit(row, index)
      }
    },
    // 单元格新增
    rowCellAdd(obj = {}) {
      const len = this.list.length
      this.list.push(
        this.deepClone(
          Object.assign(
            this.tableForm,
            {
              $cellEdit: true,
              $index: len
            },
            obj
          )
        )
      )
      this.formIndexList.push(len)
    },
    // 行取消
    rowCanel(row, index) {
      this.oldFormData = {}
      if (this.validatenull(row[this.idKey])) {
        this.list.splice(index, 1)
        return
      }
      this.formCascaderList[index].$cellEdit = false
      // 设置行数据
      this.$set(this.list, index, this.formCascaderList[index])
      // 设置级联字典
      this.$set(this.cascaderDIC, index, this.cascaderDicList[index])
      this.formIndexList.splice(this.formIndexList.indexOf(index), 1)
    },
    // 单元格编辑
    rowCellEdit(row, index) {
      row.$cellEdit = true
      this.oldFormData = this.deepClone(row)
      this.tableForm = this.rowClone(row)
      this.$emit('input', this.tableForm)
      this.$set(this.list, index, row)
      // 缓冲行数据
      this.formCascaderList[index] = this.deepClone(row)
      // 缓冲级联字典
      this.cascaderDicList[index] = this.deepClone(this.cascaderDIC[index])
      setTimeout(() => {
        this.formIndexList.push(index)
      }, 1000)
    },
    // 单元格更新
    rowCellUpdate(row, index) {
      this.asyncValidator(this.formCellRules, row)
        .then((res) => {
          this.$refs.dialogForm.keyBtn = true
          this.$emit(
            'row-update',
            row,
            index,
            () => {
              row.$cellEdit = false
              this.$set(this.list, index, row)
            },
            this.oldFormData,
            () => {
              this.$refs.dialogForm.keyBtn = false
            }
          )
        })
        .catch((errors) => {
          this.$message.warning(errors[0].message || errors[0])
        })
    },
    rowAdd() {
      this.boxType = 'add'
      if (!this.tableOption.customAdd) {
        this.$refs.dialogForm.show('add')
      } else {
        this.$emit('custom-add')
      }
    },
    // 保存请求
    rowSave(isClose = true) {
      this.$refs.dialogForm.rowSave(isClose)
    },
    // 对象克隆
    rowClone(row) {
      const rowData = {}
      Object.keys(row).forEach((ele) => {
        if (!['_parent', 'children'].includes(ele)) {
          rowData[ele] = row[ele]
        }
        if(Object.prototype.toString.call(res[ele])=="[object String]") {
          rowData[ele] = transferText(res[ele])
        }
      })
      return rowData
    },
    // 搜索
    searchChange() {
      this.$refs.headerSearch.searchChange()
    },
    // 清空
    searchReset() {
      this.$refs.headerSearch.searchReset()
    },
    // 导出excel
    exportExcel() {
      this.$emit('export-excel', this.selection)
    },
    // 导出excel
    exportExcelAll() {
      this.$emit('export-excel-all')
    },
    // 打印
    importExcel() {
      this.$emit('import-excel')
    },
    deleteRows() {
      this.$emit('delete', this.tableSelect)
    },
    // 编辑
    rowEdit(row, index) {
      this.boxType = 'edit'
      if (!this.tableOption.customEdit) {
        this.fetchFormData(row).then((res) => {
          // chore: 新增字符串反转实体字符
          res && Object.keys(res).forEach(item => {
            if (Object.prototype.toString.call(res[item]) == "[object String]") {
              res[item] = transferText(res[item])
            }
          })
          // this.oldFormData = this.tableOption.formateForm
          //   ? this.tableOption.formateForm(res)
          //   : res
          this.tableForm = this.tableOption.formateForm
            ? this.tableOption.formateForm(res)
            : res
          this.tableOption.fetchCallback && this.tableOption.fetchCallback()
        })
        this.$emit('input', this.tableForm)
        this.tableIndex = index
        this.$refs.dialogForm.show('edit', index)
      } else {
        this.$emit('custom-edit', row, index)
      }
    },

    // 查看
    rowView(row, index) {
      this.boxType = 'view'
      if (!this.tableOption.customView) {
        this.tableForm = this.rowClone(row)
        this.tableIndex = index
        this.$refs.dialogForm.show('view')
      } else {
        this.$emit('custom-view', row, index)
      }
    },
    // 查看
    urlView(row, index) {
      this.boxType = 'view'
      this.tableIndex = index
      this.keyBtn = true
      this.getViewData(row)
    },
    // 查看回调
    viewOpen(row) {
      const callack = () => {
        this.$nextTick(() => {
          this.viewVisible = true
        })
      }
      if (typeof this.$parent.beforeOpen === 'function') {
        this.$parent.beforeOpen(callack, this.boxType, row)
      } else {
        callack()
      }
    },
    // 查看
    view(row, idx) {
      if (!this.tableOption.customView) {
        this.urlView(row, idx)
      } else {
        this.$emit('custom-view', row, idx)
      }
    },
    // 删除
    rowDel(row, index) {
      if (this.tableOption.deleteUrl) {
        this.deleteItem(row)
      } else {
        this.$emit('row-del', row, index)
      }
    },
    // 清空表单
    resetForm() {
      this.$refs.dialogForm.resetForm()
      this.$emit('input', this.tableForm)
    },
    // 搜索指定的属性配置
    findColumnIndex(value) {
      return this.findArray(this.propOption, value, 'prop')
    },
    // 合并行
    tableSpanMethod(param) {
      if (typeof this.spanMethod === 'function') return this.spanMethod(param)
    },
    // 合集统计逻辑
    tableSummaryMethod(param) {
      // 如果自己写逻辑则调用summaryMethod方法
      if (typeof this.summaryMethod === 'function') {
        return this.summaryMethod(param)
      }
      const { columns, data } = param
      const sums = []
      if (columns.length > 0) {
        columns.forEach((column, index) => {
          const currItem = this.sumColumnList.find(
            (item) => item.name === column.property
          )
          if (index === 0) {
            sums[index] = this.tableOption.sumText || config.sumText
          } else if (currItem) {
            switch (currItem.type) {
              case 'count':
                sums[index] = '计数:' + data.length
                break
              case 'avg':
                const avgValues = data.map((item) =>
                  Number(item[column.property])
                )
                let nowindex = 1
                sums[index] = avgValues.reduce((perv, curr) => {
                  const value = Number(curr)
                  if (!isNaN(value)) {
                    return (perv + curr) / nowindex++
                  } else {
                    return perv
                  }
                }, 0)
                sums[index] = '平均:' + sums[index].toFixed(2)
                break
              case 'sum':
                const values = data.map((item) => Number(item[column.property]))
                sums[index] = values.reduce((perv, curr) => {
                  const value = Number(curr)
                  if (!isNaN(value)) {
                    return perv + curr
                  } else {
                    return perv
                  }
                }, 0)
                sums[index] = sums[index].toFixed(2)
                break
            }
          } else {
            sums[index] = '-'
          }
        })
      }
      this.sumsList = sums
      return sums
    },
    // 清空某个表单元素
    clearFormItem(prop, refname = 'dialogForm') {
      this.$refs[refname] && this.$refs[refname].clearFormItem(prop)
    }
  }
})
</script>
